import { createContext, useContext } from 'react';

/*
 * The toast context and its hook, separated from the provider component.
 *
 * Not a style choice — `react-refresh` cannot hot-reload a module that exports
 * both a component and something else, so a file holding `ToastProvider` and
 * `useToast` loses every toast on save. The provider is in
 * `@/components/ui/toast`; this is the part everything else imports.
 */

export interface ToastApi {
  success: (message: string) => void;
  error: (message: string) => void;
}

export const ToastContext = createContext<ToastApi | null>(null);

/** `const toast = useToast(); toast.success('Job saved.')` */
export function useToast(): ToastApi {
  const api = useContext(ToastContext);
  if (!api) {
    throw new Error('useToast must be used inside a <ToastProvider>. It wraps the app in App.tsx.');
  }
  return api;
}
